import React, { FC, MouseEvent } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { ReactComponent as MoreIcon } from 'assets/image/more.svg';
import { ReactComponent as TrashIcon } from 'assets/image/trash-light.svg';
import { ReactComponent as PencilIcon } from 'assets/image/pencil-light.svg';

import cellStyles from 'shared/components/Table/CellRenderers/CellDefault.module.scss';

import styles from '../SuperAdminPostsTableNew.module.scss';

type PostRowActionsProps = {
	isOpen: boolean;
	anchorEl: null | HTMLElement;
	onMenuOpen: (_event: MouseEvent<HTMLButtonElement>) => void;
	onMenuClose: () => void;
	onEditClick: () => void;
	onDeleteClick: () => void;
};

const useMenuStyles = makeStyles({
	paper: {
		boxShadow: 'none',
		border: '1px solid rgba(33, 75, 165, 0.5)',
		borderRadius: '10px',
	},
	list: {
		width: '120px',
		paddingTop: '0px',
		paddingBottom: '0px',
	},
	root: {
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '22px',
	},
});

const PostRowActions: FC<PostRowActionsProps> = ({
	isOpen,
	anchorEl,
	onMenuOpen,
	onMenuClose,
	onEditClick,
	onDeleteClick,
}) => {
	const classes = useMenuStyles();

	return (
		<div className={`${cellStyles.main} ${cellStyles.options} ${styles.rowActions}`}>
			<Button
				onClick={event => {
					event.stopPropagation();
					onMenuOpen(event);
				}}
				className={styles.moreButton}
				title="View actions"
				aria-label="View actions"
			>
				<MoreIcon />
			</Button>
			<Menu
				anchorEl={anchorEl}
				onClose={onMenuClose}
				open={isOpen}
				classes={{ paper: classes.paper, list: classes.list }}
			>
				<MenuItem
					className={styles.menuItem}
					onClick={event => {
						event.stopPropagation();
						onEditClick();
					}}
					classes={{ root: classes.root }}
				>
					<PencilIcon className={styles.menuIcon} />
					<span>Edit</span>
				</MenuItem>
				<MenuItem
					className={styles.menuItem}
					onClick={event => {
						event.stopPropagation();
						onDeleteClick();
					}}
					classes={{ root: classes.root }}
				>
					<TrashIcon className={styles.menuIcon} />
					<span>Delete</span>
				</MenuItem>
			</Menu>
		</div>
	);
};

export default PostRowActions;
